<template>
  <button type="button" @click="$emit('click')" class="rounded-full p-2">
    <Icon v-if="icon" :name="icon" />
    <slot v-else />
  </button>
</template>

<script>
export default {
  name: 'ButtonIcon',
  components: {
    Icon: () => import('@/Components/Icon'),
  },
  props: {
    icon: { type: String, required: false },
  },
}
</script>

<style></style>
